export const mainSlider = () => {
  document.querySelectorAll('.slider-hero .swiper').forEach((galleryHero) => {
   
    const swiper = new Swiper(galleryHero, {
      grabCursor: true,
      loop: true,
      items: 1,
      speed: 600,
      effect: 'fade',
      parallax: false,
      animationTimingFunction: 'ease',
      keyboard: {
        enabled: true,
      },
      autoplay: {
        delay: slides.rotate?5e3:5e9,
        pauseOnMouseEnter: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    swiper.on('slideChange', (swiper) => {
      swiperPreload(swiper, 2)
    });

  });

  const swiperPreload = (swiper, n) => {
    if (!n) n = 2;
    swiper
        .slides
        .slice(swiper.activeIndex, swiper.activeIndex + n + 1)
        .map(slide => slide.querySelectorAll('[data-src]'))
        .forEach(nodes => {
          nodes.forEach(node => {
            node.setAttribute('src', node.dataset.src);
            node.removeAttribute('data-src');
          });
        });
  };

};
